var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemsInCart > 0)?_c('v-btn',{staticClass:"mt-15 mr-n2",attrs:{"fixed":"","fab":"","top":"","right":"","color":"secondary"},on:{"click":function($event){return _vm.$emit('openCart')}}},[_c('v-badge',{attrs:{"content":_vm.itemsInCart,"value":_vm.itemsInCart,"color":"secondary"}},[_c('v-icon',[_vm._v("mdi-cart-outline")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }